<template>
  <div class="campaign-template animate fadeIn" v-if="page && product">
    <div class="container">
      <div class="campaign-header">
        <h1 class="page-title">บริจาคในโอกาสพิเศษของคุณหรือเพื่อนของคุณ</h1>
        <h2 class="sub-title">ให้โอกาสทางการศึกษากับน้องๆ ที่ด้อยโอกาส</h2>
      </div>
    </div>

    <div class="container pd-0" v-if="!(page.data.total_product_price > 0)">
      <div class="col-md-push-1 col-md-10 col-lg-push-2 col-lg-8">
        <progress-step :steps="['1 สร้างเพจ', '2 เข้าสู่ระบบ', '3 บริจาค']" :active="3" />
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <div class="view-page-card-content">
            <page-card
              ref="card"
              :type="form.type"
              :name="form.name"
              :date="date"
              :custom-title="form.custom_type"
              :top-image="form.top_image"
              :bottom-image="form.bottom_image"
              :avatar-image="form.avatar_image"
              :editing="editing"
              :page="page"
              @edit="edit"
              @cancel="cancelEdit" />
          </div>

          <div class="block-border radius block shadow" v-if="editing">
            <page-form v-model="form" :show-ecard-form="false" submit-button-text="บันทึก" @submit="update" />
          </div>

          <div class="block-border radius block shadow" v-if="!editing">
            <div v-if="page.data.message">
              {{ page.data.message }}
              <hr class="bd" />
            </div>
            <donor-list :page="page" v-if="page"/>
          </div>

        </div>

        <div class="col-md-4">
          <div class="block-border radius block shadow">
            <div class="donate-amount">
              <div class="-label">จำนวนเงินบริจาคของคุณ</div>
              <div class="amount">{{ page.data.total_product_price | comma }} บาท</div>
            </div>

            <funding-goal
              ref="fundingGoal"
              :target="donationTarget"
              :amount="donationAmount"
              :end-date="page.data.end_date"
              :percent="donationProgress"/>

            <div v-if="page.status === $const.PAGE_STATUSES.PUBLISHED && page.data.total_product_price > 0">
              <hr style="margin: 20px -20px 0" />
              <h4 class="text-center mt-15">แชร์เพจนี้</h4>
              <div class="share text-center" style="margin: 0 -10px;">
                <vue-goodshare-facebook
                  :page_url="url+'?v='+page.changed"
                  title_social="Facebook"
                  has_icon />
                <share-line-button
                  :page_url="url+'?v='+page.changed"
                  title_social="Line"
                  has_icon />
                <div class="share-email button-social">
                  <a href="#" @click.prevent="$refs.shareEmailPopup.open"><i class="far fa-envelope"></i>&nbsp;ส่ง e-card</a>
                </div>
              </div>
              <!-- Modal -->

              <share-email-popup :page="page" ref="shareEmailPopup" />

            </div>
          </div>

          <div class="block-border radius block shadow" v-if="canDonate && !editing">
            <donate-choice
              v-if="product"
              :choices="[200, 500, 2500, 5000]"
              :custom="true"
              :defaults="500"
              :minimum="20"
              :show-donate-type="false"
              :product="product"
              @change="amountChanged"
              ref="donateChoice" />

            <div class="">
              <div class="">
                <label for="donor-message">ข้อความอวยพร</label>
                <textarea class="form__text" id="donor-message" v-model="attributes.info.message"></textarea>
              </div>
              <div class="">
                <label for="donor-name">ชื่อผู้บริจาค</label>
                <input class="form__text" type="text" id="donor-name" v-model="attributes.info.name" placeholder="เว้นว่างไว้หากไม่ประสงค์ออกนาม" />
              </div>
            </div>

            <product-cart-action
              v-if="product"
              buy-now-text="บริจาค"
              :stockAvailable="false"
              :attributes="attributes"
              :product="product"
              :initialQuantity="1"
              :addToCartButton="false"
              :buyNowButton="false"
              :style="{margin:0}"
              ref="cartAction" />

            <div class="donate__wrapper">
              <button type="button" class="btn btn--purple btn--default ma-auto" @click.prevent="donate">บริจาค</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import DonateChoice from '@/components/ProductDonateChoice'
  import DonorList from '@/components/DonorList'
  import FundingGoal from '@/components/FundingGoal'
  import PageCard from './card'
  import PageForm from './form'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProgressStep from '@/components/ProgressStep'
  import ShareEmailPopup from '@/components/ShareEmailPopup'
  import ShareLineButton from '@/components/ShareLineButton'
  import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook'

  export default {
    name: 'PageViewSpecialEvent',

    components: {
      DonateChoice,
      DonorList,
      FundingGoal,
      PageCard,
      PageForm,
      ProductCartAction,
      ProgressStep,
      ShareEmailPopup,
      ShareLineButton,
      VueGoodshareFacebook
    },

    props: {
      page: {
        type: Object,
        default: null
      },
      product: {
        type: Object,
        default: null,
        required: true
      },
      canUpload: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      date () {
        const month = this.$const.MONTH_LIST.find(item => item.value === this.form.month)
        if (month) {
          return `${parseInt(this.form.day)} ${month.name}`
        } else {
          return ''
        }
      },

      pageTitle () {
        if (this.form.type === this.$const.SPECIAL_EVENT_TYPES.OTHER) {
          return this.form.custom_type
        } else {
          return Object.keys(this.$const.SPECIAL_EVENT_TYPES).find(key => this.$const.SPECIAL_EVENT_TYPES[key] === this.form.type)
        }
      },

      url () {
        if (this.page.code.startsWith('blank') || !this.page.code) {
          return `${window.location.origin}/pages/${this.page.id}`
        } else {
          return `${window.location.origin}/${this.page.code}`
        }
      },

      donationProgress () {
        const progress = Math.floor((this.donationAmount / this.donationTarget) * 100)
        if (!isNaN(progress)) {
          return progress
        }
        return 0
      },

      donationAmount () {
        return this.page.data.total_product_price || 0
      },

      donationTarget () {
        const target = parseInt(this.page.data.target)
        if (!isNaN(target)) {
          return target
        }
        return 0
      },

      remainingDays () {
        return this.$utils.getRemainingDays(this.page.data.end_date)
      },

      isOwner () {
        return this.$store.state.user && this.page.member_id === this.$store.state.user.uuid
      },

      canDonate () {
        return !((this.page.data.total_product_price === 0 && !this.isOwner) || (this.page.data.end_date && this.remainingDays <= 0))
      }
    },

    data () {
      return {
        editing: false,
        showEditLink: true,
        attributes: {
          page: null,
          info: {
            name: '',
            message: ''
          }
        },
        form: {
          title: '',
          message: '',
          type: this.$const.SPECIAL_EVENT_TYPES.BIRTHDAY,
          custom_type: '',
          name: '',
          day: '',
          month: '',
          target: '',
          end_date: '',
          send_ecard: false,
          send_ecard_emails: [''],
          top_image: '',
          bottom_image: '',
          avatar_image: '',
          page: null
        },
        donateType: ''
      }
    },

    created () {
      const isActive = this.page.data.total_product_price > 0
      const isOwner = this.$store.state.user && this.page.member_id === this.$store.state.user.uuid
      if (!isActive && !isOwner) {
        this.$router.push('/')
      }
      this.initForm()
    },

    mounted () {
      this.attributes.page = this.page
    },

    methods: {
      initForm () {
        this.form.title = this.page.title || ''
        this.form.type = this.page.data.type || 1
        this.form.custom_type = this.page.data.custom_type || ''
        this.form.name = this.page.data.name || ''
        this.form.message = this.page.data.message || ''
        this.form.day = this.page.data.day || ''
        this.form.month = this.page.data.month || ''
        this.form.target = this.page.data.target || ''
        this.form.end_date = this.page.data.end_date || ''
        this.form.send_ecard = this.page.data.send_ecard || false
        this.form.send_ecard_emails = this.page.data.send_ecard_emails || []
        this.form.top_image = this.page.data.top_image || ''
        this.form.bottom_image = this.page.data.bottom_image || ''
        this.form.avatar_image = this.page.image || ''
        this.form.page = this.page
      },

      amountChanged (amount) {
        this.product.price = amount
      },

      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }
        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      },

      update (data) {
        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: 'กำลังบันทึกข้อมูล...',
          okButton: false
        })

        const payload = JSON.parse(JSON.stringify(this.page))
        payload.title = data.title
        payload.data = Object.assign({}, data)
        delete payload.status
        delete payload.data.title
        delete payload.data.total_product_price
        delete payload.data.total_product_quantity
        delete payload.data.page
        delete payload.data.last_donate
        delete payload.data.last_updated

        this.$refs.card.captureCanvasToS3().then(result => {
          payload.image = result.image.split('?')[0]
          payload.share_image = result.shareImage.split('?')[0]
          payload.data.top_image = result.topImage.split('?')[0]
          payload.data = JSON.stringify(payload.data)

          this.$http.post(`pages/${this.page.id}`, payload).then(resp => {
            this.cancelEdit()

            try {
              this.page.data = JSON.parse(resp.body.data)
            } catch (e) {
              console.log(e)
              this.page.data = {}
            }

            let modal = this.$modal
            let url = this.url
            window.FB.api('https://graph.facebook.com/', 'post', {
              id: url,
              scrape: true,
              // unimportant token
              access_token: 'EAACX6RdNZAkYBAB8jrduLNBTwMy7huVvkSVl5QyQdLe59PudGE5vZCTDjmnMKIMT5iYZAOaqO4tZAIRUt20XLg9AblU8kDSZCEsEF3N9TfsUqHXZC638wndY7YR8oqxLo7zjkxlm66Tc4Xw9NMZCYDUhyxhajID5WWjcMZBwRkKWtAZDZD'
            }, function (response) {
              console.log(response)
              modal.show({
                title: 'สำเร็จ',
                text: 'อัพเดทข้อมูลสำเร็จ'
              })
            })
          })
          .catch(err => {
            console.log(err)
            this.$modal.show({
              title: 'เกิดข้อผิดพลาด',
              text: `ไม่สามารถบันทึกข้อมูลได้`
            })
          })
        })
      },

      edit () {
        this.editing = true
      },

      cancelEdit () {
        this.editing = false
        this.$refs.card.editMode = false
      }
    },

    watch: {
      'form.type': function () {
        this.$nextTick(() => {
          if (this.editing) {
            this.$refs.card.updateBottomImage()
          }
          this.$refs.card.preloadImage('bottomImageSrc', 'bottomImageData')
        })
      }
    }
  }
</script>

<style lang="scss">
  .wrapper-preview {
    .page-card-content {
      border: 10px solid #fff;
    }
  }
</style>

<style lang="scss" scoped>
@media all and (max-width: 991px) {
  .view-page-card-content {
    margin-left: -15px;
    margin-right: -15px;
  }
}

 hr.bd  {
   border-bottom: 2px solid #979797;
   border-top: 0;
   margin: 1.5em -20px;
 }

 .donate-amount {
   margin-bottom: 1em;
   .-label { color: #595959; }
   .amount {
     font-weight: 500;
     color: #F6931D;
     font-size: 2em;
     line-height: 1.5em;
   }
 }

 .donate__wrapper {
   margin: 10px 0;
 }
 .share {
   .button-social {
     align-items: center;
     padding: 3px 5px;
     font-size: 13px;
     border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    display: inline-flex;
    margin: 3px 1.5px;
    opacity: 1.0;
    transition: opacity 0.5s;
    height: 28px;
    &:hover {
      opacity: 0.8;
    }
   }
   .share-email {
     background: #404040;
     color: #fff;
     padding: 3px 5px;
     font-size: 13px;
     > a { color: #fff;

     }
   }
 }

 .modal__body {
   .modal__content {
     max-height: 400px;
     overflow-y: auto;
   }
 }


</style>



// WEBPACK FOOTER //
// view.vue?1ab343a2